import { isMobile } from '../helpers/utils'

window.addEventListener("DOMContentLoaded", (event) => {
    let elements = [...document.getElementsByClassName('js-background-image')].filter(element => element.dataset.src).map(element => ({ src: parseJSON(element.dataset.src), DOMelement: element }))
    elements.forEach(element => {
        const mobileSrc = element.src.mobile
        if (isMobile() && mobileSrc) {
            element.DOMelement.style.backgroundImage = `url(${mobileSrc})`
        } else {
            element.DOMelement.style.backgroundImage = `url(${element.src.desktop})`
        }
    })
});

function parseJSON(string) {
    return JSON.parse(string.split('\'').join('"'))
}